import axios from '../../config/axios';
import apiPaths from '../apiPaths';

const onGetPoliciesToRisks = (params) => axios.get(apiPaths.policiesToRisksBase, { params });

const onCreatePoliciesToRisks = (policiesToRisks) => axios.post(apiPaths.policiesToRisksBase, policiesToRisks);

const onDeletePoliciesToRisks = (policiesToRisksIds) =>
  axios.post(`${apiPaths.policiesToRisksBase}/delete-many`, policiesToRisksIds);

export { onGetPoliciesToRisks, onCreatePoliciesToRisks, onDeletePoliciesToRisks };
